module.exports = __webpack_public_path__ + "img/Chinese-light.dff0d759.png";